exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5c1630ea] .van-grid-item .van-grid-item__content{background-color:rgba(255,0,255,0);padding:5px}.title_cell[data-v-5c1630ea]{padding:0 1px;background-color:transparent}", ""]);

// exports
